import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../../environments/environment';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-super-admin-dashboard',
  templateUrl: './super-admin-dashboard.component.html',
  styleUrls: ['./super-admin-dashboard.component.scss']
})
export class SuperAdminDashboardComponent {
  env = environment;
  ngrxAccessGroup: any;
  menu_links: any;

  constructor(
    public ngrxstore: Store<any>,
    private router: Router
  ) {}

  ngOnInit() {
    this.ngrxAccessGroup = this.ngrxstore.select<any>((state) => state.profile.accessGroupData);
    this.ngrxAccessGroup.subscribe(message => {
      if (message) {
        this.menu_links = message;
      }
    });
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  toggleMenu() {
    // Placeholder — menu toggle handled by navigation component
  }
}
